import { GITHUB_AUTH_FLOW, IMPERSONATED_USER_SUB } from "../../constants";

const { PROVIDER, GITHUB_USER_INFO } = GITHUB_AUTH_FLOW;

const addGithubToken = async (config) => {
  const impersonatedUserSub = sessionStorage.getItem(IMPERSONATED_USER_SUB);
  const userInfo = sessionStorage.getItem(GITHUB_USER_INFO);
  const { accessToken } = JSON.parse(userInfo);
  const provider = sessionStorage.getItem(PROVIDER);
  const authorizationToken = `Bearer ${accessToken}`;
  return {
    ...config,
    headers: {
      ...config.headers,
      provider,
      Authorization: authorizationToken,
      ...(impersonatedUserSub && { impersonatedUserSub }),
    },
  };
};

export default addGithubToken;
